import { ReactNode } from 'react';

/**
 * Lays subtle axis titles around a chart as plain HTML — outside the SVG, so
 * they can never collide with tick labels regardless of tick width. The chart
 * fills the remaining space.
 */
export function ChartAxisTitles({
  yTitle,
  xTitle,
  children,
}: {
  yTitle?: string;
  xTitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex h-full w-full gap-1">
      {yTitle && (
        <div className="flex shrink-0 items-center">
          <span className="rotate-180 text-[11px] text-muted-foreground [writing-mode:vertical-rl]">
            {yTitle}
          </span>
        </div>
      )}
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <div className="min-h-0 flex-1">{children}</div>
        {xTitle && (
          <div className="text-center text-[11px] text-muted-foreground">
            {xTitle}
          </div>
        )}
      </div>
    </div>
  );
}
